
/**
 * @imports
 */
import DOMInit from '@webqit/browser-pie/src/dom/index.js';
import ScopedHTML from './index.js';

/**
 * @init
 */
ScopedHTML(DOMInit(window));